var GUI = {
	blind_toggle : function(element_to_toggle, causing_element, options){
		if (!Array.isArray(element_to_toggle)) {
			element_to_toggle = [element_to_toggle];
		}
		element_to_toggle.each(function(el, idx) {
			element_to_toggle[idx] = $(el);
		});
		causing_element = $(causing_element) || element_to_toggle[0];
		element_to_toggle.each(function(el) {
			if(!el) // This occurs on element_to_toggle[1] of "Hide Lines" inside of components.
				return;
			options = Object.extend( {duration: 0.2, queue: { position: 'end', scope: el.identify() } }, options);
			if(causing_element.hasClassName('open')){
				Effect.BlindDown(el, options);
			} else {
				Effect.BlindUp(el, options);
			}
		});
		if(causing_element.hasClassName('fa fa-angle-down'))
			causing_element.removeClassName('fa fa-angle-down').addClassName('fa fa-angle-up');
		else if (causing_element.hasClassName('fa fa-angle-up'))
			causing_element.removeClassName('fa fa-angle-up').addClassName('fa fa-angle-down');
		if(causing_element.hasClassName('fa fa-plus-circle'))
			causing_element.removeClassName('fa fa-plus-circle').addClassName('fa fa-minus-circle');
		else if (causing_element.hasClassName('fa fa-minus-circle'))
			causing_element.removeClassName('fa fa-minus-circle').addClassName('fa fa-plus-circle');
		if(causing_element.hasClassName('fa fa-toggle-on'))
			causing_element.removeClassName('fa fa-toggle-on').addClassName('fa fa-toggle-off');
		else if (causing_element.hasClassName('fa fa-toggle-off'))
			causing_element.removeClassName('fa fa-toggle-off').addClassName('fa fa-toggle-on');
		if (causing_element.hasClassName('open'))
			causing_element.removeClassName('open').addClassName('close');
		else
			causing_element.removeClassName('close').addClassName('open');
	},
	copy : Object.extend(function(trigger, which, post_processing, callback){
		post_processing = post_processing || GUI.copy.post;
		const isRow = theOrder?.isTypeProject() ? true : (trigger.up('tbody') && trigger.up('tbody').next());
		var ele = theOrder?.isTypeProject() ? trigger : $(trigger).removeClassName('even').up(isRow ? 'tr' : '.product');
		var num, name = ele.down('.qty').getAttribute('name'), template = ele.innerHTML;
		if(which){
			name = name.slice(name.indexOf('[') + 1);
			num = name.slice(0, name.indexOf(']'));
		} else {
			name = name.slice(0, -7);
			num = name.slice(name.lastIndexOf('[') + 1);
		}
		var new_num = GUI.get_num();
		if (theOrder?.isTypeProject()) {
			new_num = "n_" + Date.now();
		}
		template  = template.replace(new RegExp('\\[' + num + '\\]', 'g'), '[' + new_num + ']')
							.replace(new RegExp('_' + num, 'g'), '_' + new_num)
							.replace(new RegExp("'" + num + "'", 'g'), "'" + new_num + "'") // This regex is needed just for a parameter of add_item_rows().  Watch out for unexpected conflicts (e.g. replacing numbers found in single quotes in product name/description)
							.replace(new RegExp('"' + num + '"', 'g'), '"' + new_num + '"'); // !!!! This line is temporary as the only instance is no longer used for add_item_rows() in the newer version

			/*We want to store the name of the original select field to match with the lazy loaded templates*/
			const tempEl = document.createElement(isRow ? 'tr' : 'div');
			tempEl.innerHTML = template;
			tempEl.querySelectorAll('[data-lazy="end"]').forEach((sel) => {
				const nameItem = name.slice(0, -7);
				const itemNum = nameItem.slice(nameItem.lastIndexOf('[') + 1);

				// this is used to load the options stored in window.saved_options
				sel.dataset.originalSelectTemplate = sel
					.getAttribute("name")
					.replace(new RegExp("\\[" + new_num + "\\]", "g"), "[" + num + "]")
					.replace(new RegExp("\\[" + itemNum + "\\]", "g"), "[~id~]");

				// this is used to get the select value in the original select
				sel.dataset.originalSelectName = sel
					.getAttribute("name")
					.replace(new RegExp("\\[" + new_num + "\\]", "g"), "[" + num + "]");
			});
			template = tempEl.innerHTML;

		// Copy ALL attributes except ID (if we wanted to, we could insert a time-derived ID here like copied_element_1501116092744)
		var attributes = [];

		for(var i = 0; i < ele.attributes.length; i++)
		{
			var attrib = ele.attributes[i];
			if(attrib.specified && attrib.name.toUpperCase() !== 'ID') // .specified test necessary for IE
				attributes.push(attrib.name + '="' + html_safe(attrib.value) + '"');
		}

		ele.insert({after : (['<', ele.tagName, ' ', attributes.join(' '), '>', template, '</', ele.tagName, '>'].join(''))});
		var dest = ele.next().select('input,select,textarea');
		ele.select('input,select,textarea').each(function(fe, i){
			var tempx = dest[i].name.search('is_dirty');
			if(tempx > 0){
				dest[i].value = true;
				dest[i].up('.product').addClassName('isDirty');
			}
			else{
				dest[i].value = fe.value;
			}
		});

		GUI.copy_template(num, new_num, ele.getAttribute('data-rsource'));

		const invalidate = typeof callback !== 'function';
		post_processing(ele, invalidate);

		if (typeof callback === 'function') {
			callback(am.$(ele).next());
		}

		if(ele.hasClassName('product') && ele.up('#cart_product'))
		{
			var target;
			if(ele.hasClassName('component'))
				target = $('componentset');
			else if(ele.hasClassName('supply'))
				target = $('supplyset');
			else
				target = $('productset');
			
			var kids = target.childElements();
			if(kids.length)
				kids[kids.length - 1].insert({after : ele});
			else
				target.update(ele);

			$('cart_empty').hide();
			theOrder.invalidate('items').process();
			
			//products_prices();
			//order.zebrify();
		}
	}, 
	{
		post : function(ele, invalidate = true){
			verify_component_togglers();
			verify_component_togglers('cart_product');
			if(ele.up('#product_section_inner'))
			{
//				GUI.zebrify($$('#componentset > div, #productset > div, #supplyset > div'));
				Sortable.create(ele.up(), {tag:ele.tagName, handle : 'dh'});
			}
			else if(ele.down('.dh')){
				GUI.zebrify(ele.up().childElements());
				Sortable.create(ele.up(), {tag:ele.tagName, handle : 'dh'});
			} else if(ele.up('.c_supplyset')){		// can these even be copied?
				Sortable.create(ele.up(), {tag:ele.tagName});
			} else {
				var multiline = ele.down('.clear');
				if (!multiline || multiline.length == 0)
					ele.next().select('.pao_label').invoke('remove');
				Sortable.create(ele.up(), {tag:ele.tagName, onChange : save_pao_headers});
			}
			initLightbox.myLightbox.initialize_more(ele.next());
			var form = ele.up('form,.watchform');
			if(form && GUI.loss_prevention.forms.indexOf(form) > -1) GUI.loss_prevention.form_changed();
			if($('products_total') && invalidate) {
				theOrder.invalidate('items').process();
			}
		}
	}),
	copy_element : function(el, container, id, post_processing) { //this is meant to be a bit more generic than the one above
		var data = Element.clone(el, true);
		var new_num = new Date().getTime();
		data.descendants().each( function (e) {
			$A(e.attributes).each(function(attr) {
				if (id) {
					e.setAttribute(attr.name,attr.value.replace(new RegExp('_'+id,'g'),'_n'+new_num));
					e.setAttribute(attr.name,attr.value.replace(new RegExp('\\[n?'+id+'\\]','g'),'[n'+new_num+']'));
					e.setAttribute(attr.name,attr.value.replace(new RegExp('("|\')'+id+'("|\')', 'g'), "$1n"+new_num+"$2"));
				}
				else
					e.setAttribute(attr.name, attr.value.replace(new RegExp('\\[n?[0-9]+?\\]', 'g'),'[n'+new_num+']'));
			});
		});
		data.id = data.id.replace(new RegExp('_'+id,'g'),'_n'+new_num);
		var dest = data.select('input,select,textarea');
		el.select('input,select,textarea').each(function(fe, i){
			if(dest[i].id && dest[i].id.startsWith('defaultaddr_')) {
				dest[i].checked = false;
				dest[i].removeAttribute('checked');
			} else {
				dest[i].value = fe.value;
			}
		});
		$(container).insert(data);

		// Remove initialized code editors and reset the textareas https://allmoxy.atlassian.net/browse/DEV-4168
		data.descendants().each(function (e) {
			if (e.getAttribute('data-code-editor') == 'true' && e.getAttribute('data-code-editor-initialized') == 'true') {
				$('container-editor-' + e.id).remove();
				e.removeAttribute('data-code-editor-initialized');
			}
		});
		googleplaces();
		if (post_processing)
			post_processing(data, new_num);
		return false;
	},
	copy_folder: function (old_folder, container, id, post_processing) {
		this.copy_element(old_folder, container, id, (new_folder, n) => {
			new_folder.setAttribute('data-folder-id', 'n' + n);

			const $new_folder = am.$(new_folder);

			$new_folder.find('#componentset, #productset, #supplyset, #project-line-items-set tbody').empty();
			$new_folder.find('.am-custom-dropdown-toggle').attr('data-toggle-id', 'dropdown-n' + n);
			$new_folder.find('.am-custom-dropdown').attr('id', 'dropdown-n' + n);

			am.$(old_folder).find('.component .fa-copy, .supply .fa-copy, .product .dh .fa-copy, .project-line-items tbody tr').each((_, element) => {
				GUI.copy(element, 1, null, (new_prod) => {
					let $parent = am.$(new_prod).closest('#componentset');
					if ($parent.length === 0) {
						$parent = am.$(new_prod).closest('#supplyset')
					}
					if ($parent.length === 0) {
						$parent = am.$(new_prod).closest('#productset')
					}
					if (theOrder?.isTypeProject()) {
						$parent = am.$(new_prod).closest('#project-line-items-set')
						am.$(new_prod).detach().appendTo(am.$(new_folder).find("#" + $parent.get(0).id + " tbody"));
					} else {
						am.$(new_prod).detach().appendTo(am.$(new_folder).find('#' + $parent.get(0).id))
					}
				});
			});
			init_product_quick_search_forms();
			theOrder.invalidate('items').invalidate('total').invalidate('tax')
				.invalidate('shipping').process();

			if (typeof post_processing === 'function') {
				post_processing(new_folder);
			}
		});
	},
	copy_template : function(num, new_num, instance) {
		if (GUI.templates['gi_tmpl_'+num]) // Backwards compatibility is broken
			instance = null;
		var old_id = 'gi_tmpl_' + num + '_' + instance;
		if (GUI.templates[old_id]) {
			var template = GUI.templates[old_id].replace(new RegExp('\\[' + num + '\\]', 'g'), '[' + new_num + ']');
			template = template.replace(new RegExp('_' + num, 'g'), '_' + new_num);
			template = template.replace(new RegExp("'" + num + "'", 'g'), "'" + new_num+ "'");
			template = template.replace(new RegExp('"' + num + '"', 'g'), '"' + new_num+ '"'); // !!!! This line is temporary as the only instance is no longer used for add_item_rows() in the newer version
			GUI.templates['gi_tmpl_'+new_num+'_'+instance] = template;
		}
	},

	disable : function(element)
	{
		switch(element.tagName)
		{
			case 'BUTTON':
			case 'INPUT':
			case 'SELECT':
			case 'TEXTAREA':
				element.disable();
		}
		element.addClassName('disabled');
	},

	enable : function(element)
	{
		switch(element.tagName)
		{
			case 'BUTTON':
			case 'INPUT':
			case 'SELECT':
			case 'TEXTAREA':
				element.enable();
		}
		element.removeClassName('disabled');
	},

	enumerate : function(template, where, rep, callback, focus, cb){
		if(GUI.loss_prevention.forms && GUI.loss_prevention.forms.length){
			GUI.loss_prevention.form_changed();
		}
		if(template){
			if (focus==null)
				focus = true;
			template = ((GUI.templates&&GUI.templates[template])?GUI.templates[template]:template);
			if(!rep){
				rep = [[new RegExp(/~id~/gi), GUI.get_num()]];
			} else if('number'==typeof(rep)){
				rep = [[new RegExp(/~id~/gi), rep]];
			}
			for(var i = 0; i<rep.length; i++){
				template = template.replace(rep[i][0], rep[i][1]);
			}
			var children = $(where).childElements();
			if(children.length){
				var row = children.last().insert({ after : template });
			} else {
				var row = $(where).insert( template );
			}
			var inputs = $(where).childElements().last().select('input');
			if (inputs.length && focus)
				inputs[0].focus();
            if (inputs.length > 0 && cb) {
                cb(inputs[0]);
            }
		}
		GUI.reinicializedTooltip()
		if(callback) callback($(where));
		return false;
	},
	reinicializedTooltip: function () {
		// bootstrap loads deferred on some environments; during initial HTML parsing it isn't
		// defined yet, and throwing here aborts inline GUI.enumerate() callers mid-initialization
		// (DEV-12156). Tooltips are (re)initialized at document-ready by widgets.js regardless.
		if (typeof bootstrap === 'undefined' || !bootstrap.Tooltip) return;
		const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
		const tooltipList = tooltipTriggerList.map(function(tooltipTriggerEl) {
			return new bootstrap.Tooltip(tooltipTriggerEl);
		});
	},
	enumerated_fill : function(template, where, rep, callback){
		$(where).innerHTML = '';
		return GUI.enumerate(template, $(where), rep, callback);
	},
	error_message : function(elem, advice_id, msg, repeat_errors){
		if(elem.classList.contains('am-section-input')){
			var parent = elem.up();
			var existingElement = document.getElementById(advice_id);

			if (!existingElement || existingElement.textContent !== msg) {
				if (existingElement) {
					existingElement.update(msg);
				} else {
					parent.insert({after: new Element('div', {'id': advice_id, 'class': 'validation-advice'}).update(msg)});
				}
			}
		}
		else{
			if(!$(advice_id))
				elem.insert({after: new Element('div',{'id':advice_id,'class':'validation-advice'}).update(msg)});
		}
		if(repeat_errors) // on order form
		{
			$('repeat_errors').insert(new Element('div',{'id':advice_id+'2'}).update(msg));
			$('repeat_errors').show();
		}
	},
	success_message : function(elem, advice_id, msg){
		elem.insert({after:new Element('div',{'id':advice_id,'class':'success'}).update(msg)});
	},
	fill_with : function(template, where, callback){
		if(!where) return;
		if(typeof(template)=='object' && template.tagName && template.tagName.toLowerCase() == 'select')
			template = Number($(template).childElements()[$(template).selectedIndex].getAttribute('rel'));
		if(typeof(template)=='string')
			template = ((GUI.templates&&GUI.templates[template])?GUI.templates[template]:template);

		// this line of code probably doesn't work; what's GUI.fs?
		if(typeof(template)=='number') template = GUI.templates[GUI.fs[where][template%GUI.togglers[where].length]];

		if(template) $(where).update(template); else $(where).update('');
		if(callback) callback($(where));
	},
	get_num : function(){
		if(!GUI.get_num.num){
			var num = new Date();
			GUI.get_num.num = Date.parse(num) + Math.floor(Math.random()*1000);
		}
		return GUI.get_num.num++;
	},
	// Synchronize a container's instant visiblity via templated element to a checkbox's checked state:  Upon initialization the container's content is templated then removed if the checkbox isn't checked.
	live_sync_to_checkbox : function(block, checkbox){
		checkbox = $(checkbox);
		document.observe("dom:loaded", function(){
			block = $(block);
			var id = block.identify();
			if(!GUI.templates) GUI.templates = {};
			GUI.templates[id] = block.innerHTML;
			block.update(checkbox.checked?GUI.templates[id]:'');
			checkbox.observe('click', function(ev){
				if(ev.element().checked){
					GUI.fill_with(GUI.templates[id], block);
				} else {
					if(!block.innerHTML.blank()){
						GUI.templates[id] = block.innerHTML;
						block.update('');
					}
				}
			});
		});
	},
	loss_prevention : Object.extend(function(){
		GUI.loss_prevention.form_changed = function(){
			window.onbeforeunload = function(){ return "You may have unsaved data that will be lost and cannot be recovered."; };
			// DEV-13484: the listeners only need removing once. Code editors call this on
			// every keystroke (mark_watchform_as_dirty), and re-walking every field of a big
			// form each time cost ~20ms+ per key on large product Parts pages.
			if (GUI.loss_prevention.unbound) return;
			GUI.loss_prevention.unbound = true;
			GUI.loss_prevention.forms.each(function(form){
				form.select('input, select, textarea').each(function(ele){
					ele.stopObserving('change', GUI.loss_prevention.form_changed);
					ele.stopObserving('keydown', GUI.loss_prevention.form_changed);
				});
			});
		};
		for(var i = 0; i < arguments.length; i++){
			if(arguments[i].each){	// isArray
				arguments[i].each(function(ele){
					ele = $(ele);
					if(ele) GUI.loss_prevention.forms.push(ele);
				});
			} else {
				var ele = $(arguments[i]);
				if(ele) GUI.loss_prevention.forms.push(ele);
			}
		}
		if(!GUI.loss_prevention.forms.length) return false;
		GUI.loss_prevention.forms.each(function(form){
			form.select('input, select, textarea').each(function(ele){
				ele.observe('change', GUI.loss_prevention.form_changed);
				ele.observe('keydown', GUI.loss_prevention.form_changed);
			});
		});
	},	{'forms' : []}),
	populate_ils : function(ret, list, return_item, callback){
		var data = ret.responseJSON, select = new Element('select');
		list = $('il_'+list);
		if(data){
			list.enable();
			select.insert('<option value="">--'+get_language_translation('LANG_OPT_SELECT_ONE')+'--</option>');
			for(var i=0; i < data.length; i++){
				select.insert('<option rel="'
					+ (return_item ? data[i].il_id : data[i].item_id)
					+ '" value="'
					+ (return_item ? data[i].item_id : data[i].il_id)
					+ '">'+data[i].name+'</option>');
			}
			select.selectedIndex = 0;
			if(callback)
				list.update(callback(select).innerHTML);
			else
				list.update(select.innerHTML);
		} else {
			select.insert('<option value="">No items found</option>');
			list.disable();
			if(callback) list.update(callback(select).innerHTML);
		}
	},
	prefer_this_alone : function(this_alone, class_name){
		class_name = class_name || 'preferred';
		this_alone = $(this_alone);
		var was = this_alone.checked;
		this_alone.up('div.row,tbody,#attrgrid').select('input[type=checkbox]').each(function(i){
			i.checked = false;
			i.removeAttribute('checked');
			i.up('div,tr').removeClassName(class_name);
		});
		if(!was){
			this_alone.checked = true;
			this_alone.setAttribute('checked','checked');
			this_alone.up('div,tr').addClassName(class_name);
		}
	},
	remove_div : function(elem){
		elem.remove();
	},
	select_item : function(il, is_item_id, onSuccess, onFailure){
		onSuccess = onSuccess || populate_item_data;
		onFailure = onFailure || clear_item_data;
		var params = {'table':'inventory_data'};
		params[is_item_id?'item_id':'il_id'] = $F(il);
		il = il.id.match(/\d+$/).pop();
		if(count(params) > 1){
			new Ajax.Request('ajax/', {
				parameters : params,
				onSuccess : function(ret) {
					onSuccess(ret.responseJSON, il);
				},
				onFailure : function(ret) {
					onFailure(il);
				}
			});
		} else onFailure(il);
	},

	select_item_to_move : function(il)
	{
		var params =
		{
			'table': 'moving_inventory_data',
			'from_location_id': $F('location_0'),
			'to_location_id': $('move_supply_gui').checked ? $F('to_location_0') : ($('track_to_an_order').checked ? 'order' : null),
			'item_id': il[il.selectedIndex].getAttribute('rel')
		};
		il = il.id.match(/\d+$/).pop();
		if(params.item_id)
		{
			new Ajax.Request(
				'ajax/',
				{
					parameters : params,
					onSuccess : function(ret)
					{
						populate_moving_item_data(ret.responseJSON, il);
					},
					onFailure : function(ret)
					{
						clear_item_data(il);
					}
				}
			);
		}
		else
			clear_item_data(il);
	},

	select_location : function(location, return_item, callback){
		var id = location.id.match(/\d+$/).pop();
		var val = $F(location);
		if(val.blank()){
			GUI.populate_ils({'responseJSON':null}, id);
		} else {
			new Ajax.Request('ajax/', {
				parameters : {'table':'inventory_items','location_id':val},
				onSuccess : function(ret){
					GUI.populate_ils(ret, id, return_item, callback);
				}
			});
		}
		clear_item_data(id);
		return false;
	},

	select_to_location : function()
	{
		GUI.select_item_to_move($('il_0'));
	},

	select_tab : function(e, options){
		options.class_name = options.class_name || 'selected';
		e = e.element?e.element():$(e);
		var old = e.up('div,tr').down('.' + options.class_name);
		if(old) old.removeClassName(options.class_name);
		e.addClassName(options.class_name);
		if(options.callback) options.callback();
		return false;
	},

	sync_select_toggle : function(select, container, hide_val) // this could be easily modified to accept a list of values to test on
	{
		document.observe('dom:loaded', function()
		{
			if(select.value == hide_val)
				container.hide();
		});
		select.observe('change', function(event)
		{
			if(select.value == hide_val)
				container.hide();
			else
				container.show();
		});
	},

	sort_by : function(list, by){
		list.each(function(tbody){
			var tbody_id = tbody.up().id;
			if (tbody_id.length) tbody_id = tbody_id.match(/[\d_]+$/).pop();
			if(by[tbody_id]){
				var trs = tbody.childElements();
				var row_ids = trs.collect(function(a){ return (a.childElements()[0].getAttribute('sorttable_customkey') - 0) || a.childElements()[0].innerHTML; });
				by[tbody_id].each(function(next_id){
					var ind = row_ids.indexOf(next_id);
					if(ind > -1) tbody.appendChild(trs[ind]);
				});
				GUI.zebrify(tbody.childElements());
			};
		});
	},
	// Synchronize a group of containers' instant visiblity via show/hide to a checkbox's checked state.
	sync_dynamic_to_checkbox : function(container, block_match, checkbox){
		checkbox = $(checkbox);
		document.observe("dom:loaded", function(){
			if(!checkbox.checked)
				$(container).select(block_match).invoke('hide');
		});
		checkbox.observe('click', function(ev){
			$(container).select(block_match).invoke(checkbox.checked?'show':'hide')
		});
	},
	// Synchronize a container's instant visiblity via show/hide to a checkbox's checked state.  Set condition to false to hide when checked, or pass in a custom function for testing the checkbox.
	sync_to_checkbox : function(blocks, checkbox, condition){
		if(condition === false || condition === '!'){
			condition = function(a){ return !a.checked; };
		} else if(!condition || 'function' != typeof(condition)){
			condition = function(a){ return a.checked; };
		}
		checkbox = $(checkbox);
		if(blocks.constructor == Array){
			document.observe("dom:loaded", function(){
				if(!condition(checkbox))
					blocks.invoke('hide');
			});
			checkbox.observe('click', function(ev){
				blocks.invoke(condition(checkbox)?'show':'hide')
			});
		} else {
			document.observe("dom:loaded", function(){
				if(!condition(checkbox))
					$(blocks).hide();
			});
			checkbox.observe('click', function(ev){
				GUI.toggle(condition(ev.element()), blocks);
			});
		}
	},
	// Synchronize a container's  visiblity via animated transition to a group of checkboxes' checked state (show if at least one checked)
	sync_to_checkboxes : function(block, checkboxes){
		checkboxes.each(function(cb,i){ checkboxes[i] = $(cb); })
		document.observe("dom:loaded", function() {
			if( !checkboxes.pluck('checked').any() )
				$(block).hide().addClassName('hidden');
		});
		checkboxes.each(function(checkbox){
			checkbox.observe('click', function(){
				var queue = Effect.Queues.get(block);
				if( checkboxes.pluck('checked').any() ){ //if any of the checkboxes are checked.
					if( $(block).hasClassName('hidden') ){
						$(block).removeClassName('hidden').blindDown({
							queue: {
								position: 'end',
								scope: block
							}
						});
					}
				} else {
					if( !$(block).hasClassName('hidden') ){
						$(block).addClassName('hidden').blindUp({
							queue: {
								position: 'end',
								scope: block
							}
						});
					}
				}
			});
		});
	},
	templatize : function(id, inner_only){
		if(!$(id)){
			throw('cannot templatize "'+id+'"');
			return;
		}
		if(!GUI.templates) GUI.templates = {};
		if(inner_only)
			GUI.templates[id] = $(id).innerHTML;
		else
			GUI.templates[id] = '<'+$(id).tagName+($(id).className?' class="'+$(id).className+'"':'')+'>'+$(id).innerHTML+'</'+$(id).tagName+'>';
		$(id).remove();
	},
	toggle : function(bool, block){
		bool ? $(block).show() : $(block).hide();
	},
	toggler : function(block, alternatives, initialize, callback){
		initialize = initialize===undefined?true:initialize;
		if(!GUI.togglers) GUI.togglers = {};
		if(!GUI.templates) GUI.templates = {};
		if(document.loaded) alert("Yep, that's your problem.");
		Event.observe(document,'dom:loaded',function(){
			GUI.togglers[block] = [null].concat(alternatives);
			alternatives.each(function(alt,i){
				if(!$(alt))
					return;
				var next = alternatives[(i+1)%alternatives.length];
				if(initialize===true && $(alt).down('.inlinebutton')){
					$(alt).down('.inlinebutton').setAttribute('onclick','$("'+block+'").update(GUI.templates["'+next+'"]);'+(callback?' '+callback+'("'+next+'");':'')+' return false;');
				}else if(initialize===true && $(alt).down('.am-btn--tonal')){
					$(alt).down('.am-btn--tonal').setAttribute('onclick','$("'+block+'").update(GUI.templates["'+next+'"]);'+(callback?' '+callback+'("'+next+'");':'')+' return false;');
				}else if(initialize===true && $(alt).down('.togglebtn')){
					$(alt).down('.togglebtn').setAttribute('onclick','$("'+block+'").update(GUI.templates["'+next+'"]);'+(callback?' '+callback+'("'+next+'");':'')+' return false;');
				}
				GUI.templates[alt] = $(alt).innerHTML;
				$(alt).remove();
			});
			if(initialize) $(block).update(GUI.templates[GUI.togglers[block][Number(initialize)]]);
			if(!initialize && 'function'==typeof(callback)) callback();
		});
	},
	zebrify : function(list){
		var bool = true;
		list.each(function(tr){
			if(bool) {
				tr.removeClassName('even');
				tr.addClassName('odd');
			}
			else {
				tr.removeClassName('odd');
				tr.addClassName('even');
			}
			bool = !bool;
		});
	},
	mark_watchform_as_dirty: (element) => {
		if (typeof element === 'string') {
			element = element.startsWith('#') ? element : '#' + element;
		}

		const $element = am.$(element);
		let $form = $element.closest('form.watchform');

		if ($element.is('form')) {
			$form = $element;
		}

		if ($form.length > 0) {
			GUI.loss_prevention.form_changed();
		}
	},
	swipeDetect: function (el, callback) {
		let touchsurface = el,
			swipedir,
			startX,
			startY,
			distX,
			distY,
			threshold = 30, //required min distance traveled to be considered swipe
			restraint = 400, // maximum distance allowed at the same time in perpendicular direction
			allowedTime = 1000, // maximum time allowed to travel that distance
			elapsedTime,
			startTime,
			handleswipe = callback || function (swipedir) {
			};

		touchsurface.addEventListener('touchstart', function (e) {
			const touchobj = e.changedTouches[0];
			swipedir = 'none';
			dist = 0;
			startX = touchobj.pageX;
			startY = touchobj.pageY;
			startTime = new Date().getTime(); // record time when finger first makes contact with surface
			// e.preventDefault();
		}, false);

		touchsurface.addEventListener('touchmove', function (e) {
			// e.preventDefault(); // prevent scrolling when inside DIV
		}, false);

		touchsurface.addEventListener('touchend', function (e) {
			const touchobj = e.changedTouches[0];
			distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
			distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
			elapsedTime = new Date().getTime() - startTime; // get time elapsed
			if (elapsedTime <= allowedTime) { // first condition for awipe met
				if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) { // 2nd condition for horizontal swipe met
					swipedir = (distX < 0) ? 'left' : 'right'; // if dist traveled is negative, it indicates left swipe
				} else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) { // 2nd condition for vertical swipe met
					swipedir = (distY < 0) ? 'up' : 'down'; // if dist traveled is negative, it indicates up swipe
				}
			}
			handleswipe(swipedir);
			// e.preventDefault();
		}, false);
	}
};

//this is for the tables of images as used in add/edit category and add/edit product in catalog.  see one of them for their usage.
var ImageTable = {
	add_row: function(){
		GUI.enumerate('new_image', 'image_set',null,null,false);
		GUI.zebrify($('image_set').childElements());
		ImageTable.ensure_one_is_checked();
		return false;
	},
	ensure_one_is_checked: function () {
		const $checkboxes = am.$('#image_set').find('input[name=default_image]');

		if (!$checkboxes.is(':checked')) {
			$checkboxes.last().prop('checked', true);
		}
	},
	remove_row: function(element){
		$(element).up("tr").remove();
		GUI.zebrify($("image_set").childElements());
		ImageTable.ensure_one_is_checked();

		GUI.mark_watchform_as_dirty(element);

		return false;
	}
}

function recursivelyGetBackgroundColor(element){
	do
	{
		element = $(element);
		if (element.getStyle('backgroundColor') !='transparent') {
			return element.getStyle('backgroundColor').parseColor();
		}
		element = element.up();
	}
	while (element != document.body);
}
